var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from "react";
import { GovBar, AdminSideBar, AppLayout, BreadCrumb, Icon, } from "@uigovpe/components";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logoProcon from "../../assets/logo-procon.png";
import logoPernambuco from "../../assets/logo-pernambuco-full.png";
import { COMPONENT_STRINGS } from "../../constants";
var S = COMPONENT_STRINGS.CITIZEN_LAYOUT;
var sections = [
    {
        id: "section-citizen",
        title: "Menu",
        items: [
            { id: "inicio", label: S.MENU.HOME, link: "/", icon: "home" },
            {
                id: "meus-casos",
                label: S.MENU.MY_CASES,
                link: "/my-cases",
                icon: "folder_shared",
            },
        ],
    },
];
// Mapa id-do-botão → rota, derivado de `sections`. O AdminSideBar renderiza
// cada item como <button id={item.id}> (não como <a>), então usamos o `id` para
// descobrir o destino no listener de clique. Botões fora deste mapa (ex.: o
// toggle de recolher) não são interceptados.
var linkById = new Map();
sections.forEach(function (section) {
    var _a;
    if (section.id && section.link)
        linkById.set(section.id, section.link);
    (_a = section.items) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
        var _a;
        if (item.id && item.link)
            linkById.set(item.id, item.link);
        (_a = item.subItems) === null || _a === void 0 ? void 0 : _a.forEach(function (sub) {
            if (sub.id && sub.link)
                linkById.set(sub.id, sub.link);
        });
    });
});
var getPageTitle = function (pathname) {
    if (pathname.includes("/reclamation/form") ||
        pathname.includes("/reclamation/success"))
        return S.BREADCRUMB.FORM_TITLE;
    if (pathname.includes("/my-cases"))
        return S.MENU.MY_CASES;
    return S.BREADCRUMB.HOME;
};
export var CitizenLayout = function () {
    var pathname = useLocation().pathname;
    var navigate = useNavigate();
    var pageTitle = getPageTitle(pathname);
    // O AdminSideBar (componente do BKO) não integra com o react-router: cada
    // item (Início, Meus Casos) é um <button> que navega via
    // `window.location.href = link` imperativamente no onClick (a prop
    // `onNavigate` do componente nunca é repassada internamente, então o fallback
    // sempre roda). Embarcado no portal (basename), esse href absoluto leva pra
    // raiz do domínio e cai em "Página não encontrada".
    //
    // Interceptamos num listener NATIVO em fase de CAPTURA: ele dispara antes do
    // evento chegar ao botão, e `stopImmediatePropagation` impede de vez o onClick
    // interno do componente (o onClickCapture do React + stopPropagation não
    // barrava esse onClick imperativo de forma confiável). Identificamos o destino
    // pelo `id` do botão (ver `linkById`); caminho interno → navegação SPA; link
    // externo → bloqueia. Botões sem destino mapeado (ex.: toggle) passam direto.
    var sidebarRef = useRef(null);
    useEffect(function () {
        var el = sidebarRef.current;
        if (!el)
            return;
        var onClick = function (e) {
            var _a;
            var button = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest("button");
            var link = (button === null || button === void 0 ? void 0 : button.id) ? linkById.get(button.id) : undefined;
            if (!link)
                return;
            e.preventDefault();
            e.stopImmediatePropagation();
            // Caminho interno → navegação SPA; qualquer outra coisa fica bloqueada.
            if (link.startsWith("/"))
                navigate(link);
        };
        el.addEventListener("click", onClick, true); // true = fase de captura
        return function () { return el.removeEventListener("click", onClick, true); };
    }, [navigate]);
    var breadcrumb = {
        home: {
            label: S.BREADCRUMB.HOME,
            url: "/",
            template: (_jsx(Link, __assign({ to: "/" }, { children: _jsx(Icon, { icon: "home" }) }))),
        },
        items: __spreadArray([
            { label: S.BREADCRUMB.RECLAMATION, url: "/reclamation" }
        ], (pageTitle !== S.BREADCRUMB.HOME ? [{ label: pageTitle }] : []), true),
    };
    return (_jsxs(AppLayout, { children: [_jsx(GovBar, {}), _jsxs(AppLayout.MainLayout, { children: [_jsx("div", __assign({ ref: sidebarRef, className: "contents" }, { children: _jsx(AdminSideBar, { sections: sections, title: S.SIDEBAR_TITLE, version: S.VERSION, logo: {
                                src: logoProcon,
                                alt: S.SIDEBAR_TITLE,
                                width: 40,
                                height: 40,
                            }, footerSidebarLogo: {
                                src: logoPernambuco,
                                alt: "Governo de Pernambuco",
                                width: 120,
                                height: 40,
                            }, theme: "default", className: "h-full" }) })), _jsx(AppLayout.ContentSection, { children: _jsxs(AppLayout.MainContent, { children: [_jsx(AppLayout.BreadCrumbSection, { children: _jsx(BreadCrumb, { model: breadcrumb.items, home: breadcrumb.home }) }), _jsx(AppLayout.PageContent, { children: _jsx(Outlet, {}) })] }) })] })] }));
};
